import styled from '@emotion/styled';

export const SContainer = styled.div`
  display: flex;
  justify-content: center;
`;
